import { LoadingState } from "../../../root-store/api-result.state";
import { DevicesActions } from "../actions";
import { CHDeviceClassObjectState } from "../clarehome.state";

export const chDeviceClassObjectreducer = (
    state: CHDeviceClassObjectState = {},
    action: DevicesActions.Actions = null
): CHDeviceClassObjectState => {
    switch (action.type) {
        case DevicesActions.ActionTypes.ClearAllDCOs: {
            return {};
        }
        case DevicesActions.ActionTypes.ClearDCOState: {
            let result = null;

            if (!state?.[action.payload.deviceUid]) {
                result = {
                    [action.payload.deviceClass]: { result: null, callState: LoadingState.init },
                };
            } else if (!action.payload.deviceClass) {
                result = {};
            } else {
                result = {
                    ...state[action.payload.deviceUid],
                    [action.payload.deviceClass]: { result: null, callState: LoadingState.init },
                };
            }
            return {
                ...state,
                [action.payload.deviceUid]: result,
            };
        }

        case DevicesActions.ActionTypes.ResetDCOState: {
            let result = null;
            const DEVICE_UID = action.payload.deviceUid;
            const DEVICE_CLASS = action.payload.deviceClass;

            if (!state?.[DEVICE_UID]) {
                result = {
                    [action.payload.deviceClass]: { result: null, callState: LoadingState.init },
                };
            } else if (!DEVICE_CLASS) {
                result = {};
            } else {
                result = {
                    ...state[DEVICE_UID],
                    [DEVICE_CLASS]: {
                        ...state[DEVICE_UID][DEVICE_CLASS],
                        callState: LoadingState.init,
                    },
                };
            }
            return {
                ...state,
                [action.payload.deviceUid]: result,
            };
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjects: {
            const DEVICE_UID = action.payload.deviceUid;
            const DEVICE_CLASS = action.payload.dco;

            let result = {
                [DEVICE_CLASS]: {
                    result: null,
                    callState: LoadingState.loading,
                },
            } as any;

            if (state?.[DEVICE_UID]) {
                result = {
                    ...state[DEVICE_UID],
                    [DEVICE_CLASS]: {
                        ...state[DEVICE_UID][DEVICE_CLASS],
                        callState: LoadingState.loading,
                    },
                };
            }

            return {
                ...state,
                [DEVICE_UID]: result,
            };
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjectsSuccess: {
            const DEVICE_UID = action.payload.deviceUid;
            const DEVICE_CLASS = action.payload.deviceClass;

            let result = { result: action.payload.deviceClassObjects[DEVICE_CLASS], callState: LoadingState.loaded };

            if (state?.[DEVICE_UID]) {
                result = {
                    ...state[DEVICE_UID][DEVICE_CLASS],
                    result: action.payload.deviceClassObjects[DEVICE_CLASS],
                    callState: LoadingState.loaded,
                };
            }

            return {
                ...state,
                [DEVICE_UID]: {
                    ...state[DEVICE_UID],
                    [DEVICE_CLASS]: result,
                },
            };
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjectsFailure: {
            let result = null;

            if (!state?.[action.error.requestData.deviceUid]) {
                result = {
                    [action.error.requestData.dco]: { result: null, callState: LoadingState.loaded, error: action.error.error },
                };
            } else {
                result = {
                    ...state[action.error.requestData.deviceUid],
                    [action.error.requestData.dco]: { result: null, callState: LoadingState.loaded, error: action.error.error },
                };
            }
            return {
                ...state,
                [action.error.requestData.deviceUid]: result,
            };
        }
        case DevicesActions.ActionTypes.GetDeviceClassObjectsForDevices: {
            const deviceUids = action.payload.deviceUids;
            const deviceClassName = action.payload.dco;

            const result = { ...state };

            deviceUids.forEach(uid => {
                const currentStateDevice = result?.[uid] || {};

                if (currentStateDevice) {
                    result[uid] = {
                        ...currentStateDevice,
                        [deviceClassName]: {
                            ...currentStateDevice?.[deviceClassName],
                            callState: LoadingState.loading,
                        },
                    };
                }
            });

            return result;
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjectsForDevicesSuccess: {
            const deviceClasses = action.payload.deviceClassObjects;

            const result = { ...state };

            deviceClasses.forEach(deviceClass => {
                const deviceClassName = deviceClass.DeviceClass;
                const uid: string = deviceClass.HomeDeviceUID;
                const currentStateDevice = result?.[uid] || {};

                if (currentStateDevice) {
                    result[uid] = {
                        ...currentStateDevice,
                        [deviceClassName]: {
                            ...currentStateDevice?.[deviceClassName],
                            result: deviceClass,
                            callState: LoadingState.loaded,
                        },
                    };
                }
            });

            return result;
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjectsForDevicesFailure: {
            let result = null;
            const currentState = state || {};

            Object.keys(currentState).forEach(uid => {
                if (action.dco) {
                    result = {
                        ...currentState,
                        [uid]: {
                            ...currentState[uid],
                            [action.dco]: {
                                result: null,
                                callState: LoadingState.loaded,
                                error: action.error.error,
                            },
                        },
                    };
                } else {
                    result = currentState;
                }
            });

            return result;
        }

        case DevicesActions.ActionTypes.GetDeviceClassObjectPropertySuccess:
        case DevicesActions.ActionTypes.UpdateDeviceClassObjectSuccess: {
            const DEVICE_UID = action.payload.deviceUid;
            const DEVICE_CLASS = action.payload.deviceClass;
            const PROPERTY_KEY = action.payload.propertyKey;
            const PROPERTY_VALUE = action.payload.propertyValue;

            if (state) {
                let properties = {};
                properties = {
                    ...((state[DEVICE_UID] || {})[DEVICE_CLASS]?.result?.Properties || {}),
                    [PROPERTY_KEY]: {
                        ...((state[DEVICE_UID] || {})[DEVICE_CLASS]?.result?.Properties?.[PROPERTY_KEY] || {}),
                        Value: PROPERTY_VALUE, // eslint-disable-line @typescript-eslint/naming-convention
                    },
                };

                return {
                    ...state,
                    [DEVICE_UID]: {
                        ...state[DEVICE_UID],
                        [DEVICE_CLASS]: {
                            ...(state[DEVICE_UID] || {})[DEVICE_CLASS],
                            result: {
                                ...(state[DEVICE_UID] || {})[DEVICE_CLASS]?.result,
                                Properties: properties, // eslint-disable-line @typescript-eslint/naming-convention
                            },
                            callState: LoadingState.loaded,
                        },
                    },
                };
            }
            return state;
        }

        default: {
            return state;
        }
    }
};
